// extracted by mini-css-extract-plugin
export default {"root":"_3eXTZrMO","input":"_1v5TCzoz","icon":"_33dvJPRt"};